import React, { useEffect, useState } from 'react'
import Svg from '../../../../../../component/common/Svg';
import Switch from "../../../../../../core/Switch";
import Input from "../../../../../../core/Inputs/DefaultInput";
import { useDispatch } from 'react-redux';
import { updateField } from '../../../../../../store/actions/formBuilderAction';
import { useTranslation } from 'react-i18next';

const fieldTypeBadgeStyle = {
    display: 'inline-block',
    fontSize: '10px',
    fontWeight: 600,
    padding: '1px 8px',
    borderRadius: '4px',
    marginLeft: '8px',
    verticalAlign: 'middle',
    lineHeight: '18px',
    background: '#f0f0f0',
    color: '#666',
    border: '1px solid #ddd',
}

const CustomInput = ({ data, index: idx, survey_id, language_code, setModalOpen, setModalData, setCurrentlyDeletingField, provided }) => {
    //==> STATES <==
    const [type, setType] = useState(null)
    const [label, setLabel] = useState(null)
    const [name, setName] = useState(null)
    const [options, setOptions] = useState(null)
    const [id, setId] = useState(null)
    const [isRequired, setIsRequired] = useState(false)
    const { t, i18n } = useTranslation();
    const canEditFields = window.modulePermissions.M12.edit == 1;
    //Others
    const dispatch = useDispatch()

    const getFieldTypeBadge = (fieldType, subType) => {
        const typeLabels = {
            1: { text: t('survey.builder.textfield'), email: t('survey.builder.email'), number: t('survey.builder.num'), checkbox: t('survey.builder.check'), radio: t('survey.builder.radio') },
            3: { _default: t('survey.builder.drop') },
            4: { _default: t('survey.builder.area') },
            5: { _default: t('survey.builder.hidden1') },
            6: { _default: t('survey.builder.labelField') },
        }
        const group = typeLabels[fieldType]
        if (!group) return null
        const text = group[subType] || group._default || subType
        return <span style={fieldTypeBadgeStyle}>{text}</span>
    }

    //==> FUNCTIONALITIES <==
    const handleOpenModal = (field) => {
        setModalData({
            label: label,
            name: name,
            type: type,
            id: id,
            options: options,
            field: field
        })
        setModalOpen(true)
    }

    const handleRequiredChange = (e, field) => {
        let checked = e.target.checked
        setIsRequired(checked)

        let payload = {
            language_code: language_code,
            label: label,
            name: name,
            options: null,
            fieldId: id,
            survey_id
        }
        if (type === 1) {
            if (field === 'text' || field === 'number' || field === 'email' || field === 'name') {
                const tmpOption = { 0: { ...options['0'], required: checked } }
                payload.options = tmpOption
                dispatch(updateField(payload))
            } else if (field === 'radio' || field === 'checkbox') {
                let tmpOptions = {}
                Object.keys(options).forEach((key) => {
                    tmpOptions[key] = { ...options[key], required: checked }
                })
                payload.options = tmpOptions
                dispatch(updateField(payload))
            }
        } else if (type === 3) {
            const tmpOptions = { ...options, required: checked }
            payload.options = tmpOptions
            dispatch(updateField(payload))
        } else if (type === 4) {
            const tmpOptions = { ...options, required: checked }
            payload.options = tmpOptions
            dispatch(updateField(payload))
        }
    }

    //==> EFFECTS <==
    useEffect(() => {
        if (data) {
            const tmpType = data.su_form_variable_type
            const tmpLabel = data.su_label_and_options && JSON.parse(data.su_label_and_options)[language_code]
            const tmpName = data.su_name
            const tmpOptions = data.su_options && JSON.parse(data.su_options)
            const tmpId = data.su_lead_gen_variable_id

            setLabel(tmpLabel)
            setName(tmpName)
            setOptions(tmpOptions)
            setType(tmpType)
            setId(tmpId)

            if (tmpOptions && tmpType) {
                if (tmpType === 1) {
                    const tmpAttributes = tmpOptions['0']
                    if (tmpAttributes.type === 'text' || tmpAttributes.type === 'number' || tmpAttributes.type === 'email') {
                        setIsRequired(tmpAttributes?.required ? true : false)
                    } else if (tmpAttributes.type === 'checkbox' || tmpAttributes.type === 'radio') {
                        setIsRequired(tmpAttributes?.required ? true : false)
                    }
                } else if (tmpType === 3) {
                    setIsRequired(tmpOptions.required ? true : false)
                } else if (tmpType === 4) {
                    setIsRequired(tmpOptions.required ? true : false)
                }
            }
        }
    }, [data, language_code])



    if (type === 1) {
        const tmpAttributes = options['0']
        if (tmpAttributes.type === 'text' || tmpAttributes.type === 'number' || tmpAttributes.type === 'email') {
            return (
                <>
                    <div className="form-field-wrapper d-flex mb__20">
                        <div className="input-wrap flex-grow-1">
                            {label && <label className='form-label-custom'>{label}{getFieldTypeBadge(1, tmpAttributes.type)}</label>}
                            {
                                options && Object.keys(options)?.map((key, index) => {
                                    let attributes = options[key]
                                    delete attributes.value
                                    return (
                                        <>
                                            <Input
                                                key={index}
                                                view='outlined'
                                                dense={false}
                                                color='default'
                                                label=''
                                                success={false}
                                                error={false}
                                                fill={true}
                                                errorHelperText={null}
                                                className={"formsinput"}
                                                name={name}
                                                {...attributes}
                                                readOnly={!canEditFields}
                                            />
                                        </>
                                    )
                                })
                            }

                        </div>
                        <div className="action-wrap d-flex align-items-center">
                            <div className="action-buttons d-flex align-items-center">
                                {window.modulePermissions.M12.edit == 1 && <button className='action-btn draggable'  {...provided.dragHandleProps}>
                                    <Svg name="draggable" />
                                </button>}
                                {window.modulePermissions.M12.edit == 1 && <button className='action-btn btn-edit' title= {t('survey.builder.edit1')}  onClick={() => handleOpenModal(tmpAttributes.type)}>
                                    <Svg name="edit" />
                                </button>}
                                {window.modulePermissions.M12.del == 1 && (
                                <button className='action-btn delete' title={t('survey.builder.delete')} data-bs-toggle="modal" data-bs-target="#deleteLeadGenFieldModal" onClick={() => setCurrentlyDeletingField({ name, id })}>
                                    <Svg name="section-delete" />
                                </button>
                                )}
                            </div>
                            <div className="required-option d-flex align-items-center">
                                <div className="action-wrapper d-flex accordianSwitch">
                                    < Switch
                                        type='dense'
                                        color='default'
                                        disabled={window.modulePermissions.M12.edit != 1}
                                        label={t('survey.builder.required')}
                                        fill={false}
                                        rtl={false}
                                        leftPosition={false}
                                        className='SwitchCustom'
                                        checked={isRequired}
                                        onChange={window.modulePermissions.M12.edit == 1 ? (e) => handleRequiredChange(e, tmpAttributes.type) : undefined}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else if (tmpAttributes.type === 'checkbox' || tmpAttributes.type === 'radio') {
            return (
                <div className="form-field-wrapper d-flex mb__20" >
                    <div className="input-wrap flex-grow-1">
                        <label className='form-label-custom'>{label}{getFieldTypeBadge(1, tmpAttributes.type)}</label>
                        <div className='radio-group'>
                            {
                                options && Object.keys(options)?.map((key, index) => {
                                    const attributes = options[key]
                                    const { disabled: _ignoreDisabled, ...checkboxProps } = attributes
                                    return (
                                        <div className="form-check form-check-inline ps-0" key={index}>
                                            <input className="form-check-input" name={name} id={`${tmpAttributes.type}-group${idx}_${index}`} {...checkboxProps} disabled={!canEditFields} />
                                            <label className="form-check-label" htmlFor={`${tmpAttributes.type}-group${idx}_${index}`}>{attributes.value}</label>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="action-wrap d-flex align-items-center">
                        <div className="action-buttons d-flex align-items-center">
                            {window.modulePermissions.M12.edit == 1 && <button className='action-btn draggable'   {...provided.dragHandleProps}>
                                <Svg name="draggable" />
                            </button>}
                            {window.modulePermissions.M12.edit == 1 && <button className='action-btn btn-edit' title= {t('survey.builder.edit1')} onClick={() => handleOpenModal(tmpAttributes.type)}>
                                <Svg name="edit" />
                            </button>}
                            {window.modulePermissions.M12.del == 1 && (
                            <button className='action-btn delete' title={t('survey.builder.delete')} data-bs-toggle="modal" data-bs-target="#deleteLeadGenFieldModal" onClick={() => setCurrentlyDeletingField({ name, id })}>
                                <Svg name="section-delete" />
                            </button>
                            )}
                        </div>
                        <div className="required-option d-flex align-items-center">
                            <div className="action-wrapper d-flex accordianSwitch">
                                < Switch
                                    type='dense'
                                    color='default'
                                    disabled={window.modulePermissions.M12.edit != 1}
                                    label={t('survey.builder.required')}
                                    fill={false}
                                    rtl={false}
                                    leftPosition={false}
                                    className='SwitchCustom'
                                    checked={isRequired}
                                    onChange={window.modulePermissions.M12.edit == 1 ? (e) => handleRequiredChange(e, tmpAttributes.type) : undefined}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div div className="form-field-wrapper d-flex mb__20" >
                    <div className="input-wrap flex-grow-1">
                        <label className='form-label-custom'>{label}{getFieldTypeBadge(1, tmpAttributes.type)}</label>
                        {
                            options && Object.keys(options)?.map((key, index) => {
                                const attributes = options[key]
                                const { disabled: _ignoreDisabled2, ...checkboxProps } = attributes
                                return (
                                    <input key={index} name={name} id={`checkbox-group${idx}_${index}`} {...checkboxProps} disabled={!canEditFields} />
                                )
                            })
                        }
                    </div>
                    <div className="action-wrap d-flex align-items-center">
                        <div className="action-buttons d-flex align-items-center">
                            {window.modulePermissions.M12.edit == 1 && <button className='action-btn draggable'   {...provided.dragHandleProps}>
                                <Svg name="draggable" />
                            </button>}
                            {window.modulePermissions.M12.edit == 1 && <button className='action-btn btn-edit' title= {t('survey.builder.edit1')}  onClick={() => handleOpenModal(tmpAttributes.type)}>
                                <Svg name="edit" />
                            </button>}
                            {window.modulePermissions.M12.del == 1 && (
                            <button className='action-btn delete' title={t('survey.builder.delete')}data-bs-toggle="modal" data-bs-target="#deleteLeadGenFieldModal" onClick={() => setCurrentlyDeletingField({ name, id })}>
                                <Svg name="section-delete" />
                            </button>
                            )}
                        </div>
                        <div className="required-option d-flex align-items-center">
                            <div className="action-wrapper d-flex accordianSwitch">
                                < Switch
                                    type='dense'
                                    color='default'
                                    disabled={window.modulePermissions.M12.edit != 1}
                                    label={t('survey.builder.required')}
                                    fill={false}
                                    rtl={false}
                                    leftPosition={false}
                                    className='SwitchCustom'
                                    checked={isRequired}
                                    onChange={window.modulePermissions.M12.edit == 1 ? (e) => handleRequiredChange(e, tmpAttributes.type) : undefined}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    } else if (type === 4) {
        const attributes = options
        return (
            <div className="form-field-wrapper d-flex mb__20">
                <div className="input-wrap flex-grow-1">
                    {label && <label className='form-label-custom'>{label}{getFieldTypeBadge(4)}</label>}
                    <textarea className="form-control" id="exampleFormControlTextarea1" {...attributes} readOnly={!canEditFields} />
                </div>

                <div className="action-wrap d-flex align-items-center">
                    <div className="action-buttons d-flex align-items-center">
                        {window.modulePermissions.M12.edit == 1 && <button className='action-btn draggable'   {...provided.dragHandleProps}>
                            <Svg name="draggable" />
                        </button>}
                        {window.modulePermissions.M12.edit == 1 && <button className='action-btn btn-edit' title= {t('survey.builder.edit1')}  onClick={() => handleOpenModal('textarea')}>
                            <Svg name="edit" />
                        </button>}
                        {window.modulePermissions.M12.del == 1 && (
                        <button className='action-btn delete' title={t('survey.builder.delete')} data-bs-toggle="modal" data-bs-target="#deleteLeadGenFieldModal" onClick={() => setCurrentlyDeletingField({ name, id })}>
                            <Svg name="section-delete" />
                        </button>
                        )}
                    </div>
                    <div className="required-option d-flex align-items-center">
                        <div className="action-wrapper d-flex accordianSwitch">
                            < Switch
                                type='dense'
                                color='default'
                                disabled={window.modulePermissions.M12.edit != 1}
                                label={t('survey.builder.required')}
                                fill={false}
                                rtl={false}
                                leftPosition={false}
                                className='SwitchCustom'
                                checked={isRequired}
                                onChange={window.modulePermissions.M12.edit == 1 ? (e) => handleRequiredChange(e, 'textarea') : undefined}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (type === 3) {
        const { option, placeholder } = options
        return (
            <div className="form-field-wrapper d-flex mb__20">
                <div className="input-wrap flex-grow-1">
                    <label className='form-label-custom'>{label}{getFieldTypeBadge(3)}</label>
                    <select className="form-control" name={name} disabled={!canEditFields}>
                        <option value={null}>{placeholder ?? 'Select'}</option>
                        {
                            Object.keys(option)?.map((item, index) => {
                                return (
                                    <option key={index} value={item}>{option[item]}</option>
                                )
                            })
                        }
                    </select>
                </div>
                <div className="action-wrap d-flex align-items-center">
                    <div className="action-buttons d-flex align-items-center">
                        {window.modulePermissions.M12.edit == 1 && <button className='action-btn draggable'   {...provided.dragHandleProps}>
                            <Svg name="draggable" />
                        </button>}
                        {window.modulePermissions.M12.edit == 1 && <button className='action-btn btn-edit' title= {t('survey.builder.edit1')}  onClick={() => handleOpenModal('dropdown')}>
                            <Svg name="edit" />
                        </button>}
                        {window.modulePermissions.M12.del == 1 && (
                        <button className='action-btn delete' title={t('survey.builder.delete')} data-bs-toggle="modal" data-bs-target="#deleteLeadGenFieldModal" onClick={() => setCurrentlyDeletingField({ name, id })}>
                            <Svg name="section-delete" />
                        </button>
                        )}
                    </div>
                    <div className="required-option d-flex align-items-center">
                        <div className="action-wrapper d-flex accordianSwitch">
                            < Switch
                                type='dense'
                                color='default'
                                disabled={window.modulePermissions.M12.edit != 1}
                                label={t('survey.builder.required')}
                                fill={false}
                                rtl={false}
                                leftPosition={false}
                                className='SwitchCustom'
                                checked={isRequired}
                                onChange={window.modulePermissions.M12.edit == 1 ? (e) => handleRequiredChange(e, 'dropdown') : undefined}
                            />
                        </div>

                    </div>
                </div>
            </div>
        )
    } else if (type === 6) {
        return (
            <div className="form-field-wrapper d-flex mb__20">
                <div className="input-wrap flex-grow-1">
                    <label className='form-label-custom'>{t('survey.builder.labelField')}{getFieldTypeBadge(6)}</label>
                    <div dangerouslySetInnerHTML={{ __html: label || '' }} />
                </div>
                <div className="action-wrap d-flex align-items-center">
                    <div className="action-buttons d-flex align-items-center">
                        {window.modulePermissions.M12.edit == 1 && <button className='action-btn draggable' {...provided.dragHandleProps}>
                            <Svg name="draggable" />
                        </button>}
                        {window.modulePermissions.M12.edit == 1 && <button className='action-btn btn-edit' title={t('survey.builder.edit1')} onClick={() => handleOpenModal('label')}>
                            <Svg name="edit" />
                        </button>}
                        {window.modulePermissions.M12.del == 1 && (
                            <button className='action-btn delete' title={t('survey.builder.delete')} data-bs-toggle="modal" data-bs-target="#deleteLeadGenFieldModal" onClick={() => setCurrentlyDeletingField({ name, id })}>
                                <Svg name="section-delete" />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        )
    } else if (type === 5) {
        const tmpAttributes = options['0']
        return (<><div className="form-field-wrapper d-flex mb__20">
        <div className="input-wrap flex-grow-1">
            {label && <label className='form-label-custom'>{label}{getFieldTypeBadge(5)}</label>}
            {
                options && Object.keys(options)?.map((key, index) => {
                    let attributes = options[key]
                    return (
                        <>
                            <Input 
                                value={attributes.defaultValue} 
                                placeholder={attributes.placeholder}
                                readOnly
                                className={"formsinput"} 
                                view='outlined'
                                fill={true}
                            />                            
                        </>
                    )
                })
            }

        </div>
        <div className="action-wrap d-flex align-items-center">
            <div className="action-buttons d-flex align-items-center">
                {window.modulePermissions.M12.edit == 1 && <button className='action-btn draggable'  {...provided.dragHandleProps}>
                    <Svg name="draggable" />
                </button>}
                {window.modulePermissions.M12.edit == 1 && <button className='action-btn btn-edit' title={t('survey.builder.edit1')} onClick={() => handleOpenModal(tmpAttributes.type)}>
                    <Svg name="edit" />
                </button>}
                {window.modulePermissions.M12.del == 1 && (
                <button className='action-btn delete' title={t('survey.builder.delete')} data-bs-toggle="modal" data-bs-target="#deleteLeadGenFieldModal" onClick={() => setCurrentlyDeletingField({ name, id })}>
                    <Svg name="section-delete" />
                </button>
                )}
            </div>
        </div>
    </div></>);
    }
    return ''
}

export default CustomInput